import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=926a84aa&scoped=true&"
import script from "./TheSidebar.vue?vue&type=script&lang=ts&"
export * from "./TheSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=926a84aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926a84aa",
  null
  
)

export default component.exports